import 'select2/dist/css/select2.min.css';

import $ from 'jquery';
import 'select2';
import 'select2/dist/js/i18n/ru';

$(() => {
    const $sel2 = $('.js-select2'),
        url = $sel2.data('url');
    $sel2.select2({
        language: 'ru',
        allowClear: true,
        placeholder: {
            id: -1,
            text: 'Выберите адрес...',
            selected:'selected',
        },
    });
    $sel2.select2('val', -1);
    $sel2.on('select2:select', function (e) {
        window.location.href = url + e.params.data.id + '/';
    });
});


// WEBPACK FOOTER //
// ./js/common/select2.js